import { Component } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';
import moment from 'moment';
import { OdsServices } from '../../services';
import { TakeawayServices } from '../../../takeaway/services';
import { CompCreateTakeawayPage } from '../../../components/popups/create-takeaway/create-takeaway';

/**
 * Generated class for the OdsListViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ods-list-view',
    templateUrl: 'ods-list-view.html',
})
export class OdsListViewPage {


    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        public globals: Globals,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        public modalCtrl: ModalController,
        public odsServices: OdsServices,
        public takeawayServices: TakeawayServices) {
            
        // Cargar todos los pedidos al inicio
        this.odsServices.getOrders();
        // Establecer el estado inicial a 'todos'
        this.odsServices.filter_by_state = 'all';
    }

    openSelectDatetimeModal() {
        let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
            title: this.translate.instant('general-fechas'),
            date_first: moment(this.odsServices.select_date1).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
            date_last: moment(this.odsServices.select_date2).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
            cash_bool: false,
            date_multi: true,
            select_future_dates: true,
        });
        profileModal.onDidDismiss(async data => {
            if (data) {
                this.odsServices.select_date1 = new Date(data.date_first);
                this.odsServices.select_date2 = new Date(data.date_last);
                await this.odsServices.getTables();
                await this.odsServices.getOrders();
                await this.odsServices.getTakeawayAnalytics();
            }
        });
        profileModal.present();
    }

    changeValue(type) {
        if (type == 'takeaway') {
            this.odsServices.show_takeaways = !this.odsServices.show_takeaways;
        } else {
            this.odsServices.show_deliveries = !this.odsServices.show_deliveries;
        }
        this.filter();
    }

    filter() {
        this.odsServices.filterTables();
    }

    changeFilterActive(state) {
        this.odsServices.filter_by_state = state;
        this.filter();
    }

    styleButton(state) {
        return {
            'btn-active': state === this.odsServices.filter_by_state
        };
    }

    stateColCss() {
        if (this.globals.platform_width === 'mobile') {
            let cssClasses = {
                'col-6': true
            }
            return cssClasses;
        } else {
            let cssClasses = {
                'col-auto': true
            }
            return cssClasses;
        }
    }

    btnClass(state) {
        let cssClasses = {};
        if (state === 'failed' || state === 'cancelled') { //Canceladas | Fallidas
            cssClasses = {
                'btn-outline-denied': true
            }
        } else if (state === 'stateless') { //Sin estado
            cssClasses = {
                'btn-outline-not-presented': true
            }
        } else if (state === 'accepted' || state === 'completed') { //Aceptadas | Completadas
            cssClasses = {
                'btn-outline-accepted': true
            }
        } else if (state === 'received' || state === 'delayed_15' || state === 'delayed_30') { //Pendientes | En retraso
            cssClasses = {
                'btn-outline-pending': true
            }
        } else if (state === 'sent') { //Enviado
            cssClasses = {
                'btn-outline-in-table': true
            }
        } else { //Otros
            cssClasses = {
                'btn-outline-accepted': true
            }
        }
        return cssClasses;
    }

    async openTakeaway(table) {
        // Recuperamos la uid de la mesa para abrir la view y de el index correcto
        this.takeawayServices.selected_table_uid = table.UID;
        // Buscamos la informacion del cliente
        await this.takeawayServices.getCustomer(table.customer_uid);
        await this.takeawayServices.getIndexByTableuid();
        // Info necesaria para abrir el tk
        this.takeawayServices.selected_table_tpv = table;
        this.takeawayServices.selected_type = 'takeaway';

        // Extrae el comentario del cliente del objeto table
        let customerComment = table.notes || '';         

        let profileModal = this.modalCtrl.create(CompCreateTakeawayPage, {
            update_state: true,
            table: table,
            customerComment: customerComment
        });
        profileModal.present();
    }
}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-view/ods-list-view/ods-list-view.ts